import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { style } from '../../styles';
import { ReactComponent as Icon } from '../../assets/images/notify.svg';
import useTheme from '../../state/hooks/useTheme';
import { TTheme, TStatus } from "../../types/types";
import { ReactComponent as Sucess } from '../../assets/images/success.svg'
import { ReactComponent as Info } from '../../assets/images/info.svg'
import { ReactComponent as Warning } from '../../assets/images/warning.svg'
import { ReactComponent as Critical } from '../../assets/images/critical.svg'
import { NavLink } from "react-router-dom";
import instancia from "../../instancia";
import { INotification } from "../../types/notifications";

const apiCode = process.env.REACT_APP_API_CODE;

const Container = styled.div<{ theme: TTheme, selecionado: boolean }>`
    width: 44px;
    height: 44px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all .3s linear;
    cursor: pointer;
    background-color: ${props => props.selecionado ? props.theme === 'light' ? style.colors.light["bg-primary"] : style.colors.dark["bg-primary"] : ""};
    color: ${props => props.theme === 'light' ? style.colors.light["font-color"] : style.colors.dark["font-color"]};

    &:hover {
        background-color: ${props => props.selecionado ? "" : `${style.colors.secondary}70`};
    }
`

const Badge = styled.div`
    min-width: 17px;
    height: 17px;
    padding: 0 5px;
    box-sizing: border-box;
    background-color: ${style.colors.critical};
    color: #fff;
    border-radius: 10px;
    position: absolute;
    top: 6px;
    right: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${style.font.family.semiBold};
    font-size: 10px;
    line-height: 17px;
`

const Menu = styled.div<{ theme: TTheme }>`
    width: 380px;
    max-height: 420px;
    box-sizing: border-box;
    background-color:  ${props => props.theme === 'light' ? style.colors.light["bg-secondary"] : style.colors.dark["bg-secondary"]};
    border-radius: .3rem;
    position: absolute;
    z-index: 1000;
    top: 44px;
    right: -15px;
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .3), 0 2px 6px 2px rgba(60, 64, 67, .15);
    cursor: default;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

const MenuHeader = styled.div<{ theme: TTheme }>`
    width: 100%;
    padding: .9rem 1rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${props => props.theme === 'light' ? style.colors.light["bg-primary"] : style.colors.dark["bg-primary"]};
    color: ${props => props.theme === 'light' ? style.colors.light["font-color"] : style.colors.dark["font-color"]};

    & h4 {
        margin: 0;
        font-family: ${style.font.family.medium};
        font-size: 14px;
    }
`

const HeaderAction = styled.button<{ theme: TTheme }>`
    border: none;
    background: transparent;
    color: ${style.colors.info};
    font-family: ${style.font.family.regular};
    font-size: 12px;
    cursor: pointer;

    &:disabled {
        cursor: default;
        opacity: .5;
    }
`

const MenuBody = styled.div`
    width: 100%;
    max-height: 315px;
    overflow: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`

const MenuFooter = styled(NavLink)<{ theme: TTheme }>`
    width: 100%;
    padding: .8rem 1rem;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    color: ${style.colors.info};
    font-family: ${style.font.family.medium};
    font-size: 13px;
    border-top: 1px solid ${props => props.theme === 'light' ? style.colors.light["bg-primary"] : style.colors.dark["bg-primary"]};
`

const ContainerCard = styled.button<{ status: TStatus, read: boolean }>`
    width: calc(100% - 1.2rem);
    min-height: 104px;
    border-radius: 8px;
    padding: 10px;
    box-sizing: border-box;
    border: 0;
    background-color: ${props => props.read ? `${style.colors.secondary}20` : `${style.colors[props.status]}70`};
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    transition: all .2s linear;
    cursor: pointer;
    margin: .8rem .6rem 0 .6rem;
    text-align: left;

    &:hover {
        background-color: ${props => props.read ? `${style.colors.secondary}35` : style.colors[props.status]};
    }

    &:last-child {
        margin-bottom: .8rem;
    }
`

const IconCardMenu = styled.div`
    width: 30px;
    min-width: 30px;
    height: 30px;
`

const ContainerConteudoCard = styled.div<{ read: boolean }>`
    width: 90%;
    min-height: 100%;
    margin-left: .5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    color: ${props => props.read ? '#FFFFFFCC' : '#fff'};
`

const TituloCard = styled.h4`
    font-family: ${style.font.family.medium};
    font-size: 14px;
    margin: 0;
`

const TextCard = styled.p`
    font-family: ${style.font.family.light};
    font-size: 13px;
    width: 100%;
    margin: .35rem 0;
    line-height: 1.35;
`

const MetaCard = styled.span`
    font-family: ${style.font.family.regular};
    font-size: 11px;
    opacity: .9;
`

const TimeCard = styled.span`
    font-family: ${style.font.family.semiBold};
    font-size: 11px;
    align-self: flex-end;
`

const EmptyState = styled.div<{ theme: TTheme }>`
    width: 100%;
    padding: 2rem 1rem;
    box-sizing: border-box;
    text-align: center;
    font-family: ${style.font.family.regular};
    font-size: 13px;
    color: ${props => props.theme === 'light' ? style.colors.light["font-color"] : style.colors.dark["font-color"]};
    opacity: .75;
`

const getIcon = (status: TStatus) => {
    switch(status) {
        case 'success':
            return <Sucess />
        case 'critical':
            return <Critical />
        case 'warning':
            return <Warning />
        case 'info':
        default:
            return <Info />
    }
}

const formatTime = (date?: string) => {
    if (!date) return '';

    const value = new Date(date).getTime();
    if (Number.isNaN(value)) return '';

    const diffMs = Date.now() - value;
    const diffMinutes = Math.floor(diffMs / 60000);

    if (diffMinutes < 1) return 'Agora';
    if (diffMinutes < 60) return `Há ${diffMinutes} min.`;

    const diffHours = Math.floor(diffMinutes / 60);
    if (diffHours < 24) return `Há ${diffHours}h`;

    const diffDays = Math.floor(diffHours / 24);
    return `Há ${diffDays}d`;
}

const getContractLabel = (notification: INotification) => {
    const empresa = notification.contract?.empresa;
    const service = notification.service || notification.contract?.servico;

    return [empresa, service].filter(Boolean).join(' • ');
}

const Card = ({ notification, onRead }: { notification: INotification, onRead: (notification: INotification) => void }) => {
    return (
        <ContainerCard
            type="button"
            status={notification.severity || 'info'}
            read={notification.read}
            onClick={(event) => {
                event.stopPropagation();
                onRead(notification);
            }}
        >
            <IconCardMenu>
                {getIcon(notification.severity || 'info')}
            </IconCardMenu>
            <ContainerConteudoCard read={notification.read}>
                <TituloCard>{notification.title || 'Notificação'}</TituloCard>
                <TextCard>{notification.message || 'Sem descrição.'}</TextCard>
                <MetaCard>{getContractLabel(notification) || `Contrato ${notification.contractId}`}</MetaCard>
                <TimeCard>{formatTime(notification.occurredAt || notification.createdAt)}</TimeCard>
            </ContainerConteudoCard>
        </ContainerCard>
    )
}

const Notify = () => {
    const { theme } = useTheme();
    const [open, setOpen] = useState(false);
    const [notifications, setNotifications] = useState<INotification[]>([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const loadUnreadCount = useCallback(() => {
        instancia
            .get(`/notifications/unread-count?code=${apiCode}`)
            .then(res => setUnreadCount(Number(res.data?.unreadCount || 0)))
            .catch(() => setUnreadCount(0));
    }, []);

    const loadNotifications = useCallback(() => {
        setLoading(true);

        instancia
            .get(`/notifications?code=${apiCode}`)
            .then(res => setNotifications(res.data?.notifications || []))
            .catch(() => setNotifications([]))
            .finally(() => setLoading(false));
    }, []);

    const markAsRead = async (notification: INotification) => {
        if (!notification.notificationId) return;

        try {
            await instancia.post(`/notifications/${notification.notificationId}/read?code=${apiCode}`, {});

            setNotifications(current => current.map(item =>
                item.notificationId === notification.notificationId
                    ? { ...item, read: true, readAt: new Date().toISOString() }
                    : item
            ));

            if (!notification.read) {
                setUnreadCount(current => Math.max(current - 1, 0));
            }
        } catch {}
    };

    const markAllAsRead = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        try {
            await instancia.post(`/notifications/read-all?code=${apiCode}`, {});
            setNotifications(current => current.map(item => ({ ...item, read: true, readAt: new Date().toISOString() })));
            setUnreadCount(0);
        } catch {}
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        loadUnreadCount();
        const interval = setInterval(loadUnreadCount, 30000);

        return () => clearInterval(interval);
    }, [loadUnreadCount]);

    useEffect(() => {
        if (open) {
            loadNotifications();
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [open, loadNotifications]);

    return (
        <Container selecionado={open} onClick={() => setOpen(!open)} theme={theme} ref={menuRef}>
            {unreadCount > 0 ? <Badge>{unreadCount > 99 ? '99+' : unreadCount}</Badge> : null}
            <Icon width={24} />
            {
                open ?
                    <Menu theme={theme} onClick={(event) => event.stopPropagation()}>
                        <MenuHeader theme={theme}>
                            <h4>Notificações</h4>
                            <HeaderAction theme={theme} disabled={unreadCount === 0} onClick={markAllAsRead}>
                                Marcar lidas
                            </HeaderAction>
                        </MenuHeader>
                        <MenuBody>
                            {loading ? <EmptyState theme={theme}>Carregando notificações...</EmptyState> : null}
                            {!loading && notifications.length === 0 ? <EmptyState theme={theme}>Nenhuma notificação encontrada.</EmptyState> : null}
                            {!loading && notifications.map(notification => (
                                <Card
                                    key={notification.notificationId}
                                    notification={notification}
                                    onRead={markAsRead}
                                />
                            ))}
                        </MenuBody>
                        <MenuFooter to="/notificacoes" theme={theme} onClick={() => setOpen(false)}>
                            Ver todas
                        </MenuFooter>
                    </Menu> : null
            }
        </Container>
    )
}

export default Notify;
